import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MongoDBRejectionRequest } from '../../types/mongodb'

const useRejectMongoDB = (mongoDBID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (request: MongoDBRejectionRequest) =>
			api.mongodb.rejectMongoDB(request),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['mongodb'], exact: true })
			void queryClient.invalidateQueries({ queryKey: ['mongodb', mongoDBID] })
			void queryClient.invalidateQueries({ queryKey: ['mongodb-eligibility'] })
		}
	})
}

export default useRejectMongoDB
